import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from "../../utils/constants";

class WhichEntityStatus {
  contract?: boolean;
  box?: boolean;
}

@Component({
  selector: 'aw-status-dialog',
  templateUrl: './status-legend-dialog.component.html',
  styleUrls: ['./status-legend-dialog.component.scss']
})
export class StatusLegendDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: WhichEntityStatus,
    public dialogRef: MatDialogRef<StatusLegendDialogComponent>,
  ) {


  }

  dataSource?: any;

  ngOnInit(): void {
    this.dataSource = this.data.contract ? Constants.contractStatusesExplainedForLegend : Constants.boxStatusesExplainedForLegend;
  }


}


